var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{style:(_vm.styles),attrs:{"data-toggle":"collapse","href":'#' + _vm.href,"role":"button","aria-controls":_vm.href}},[(_vm.text)?_c('ks-text',{attrs:{"text":_vm.text,"tag":_vm.tag}}):_vm._e(),(_vm.icon)?_c('ks-icon',{attrs:{"icon":_vm.icon,"abbreviated":_vm.abbreviated}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }